import React, { useEffect, useRef, useCallback } from 'react';

export const Timer = ({ show, onCompletion }) => {
  const intervalRef = useRef(null);
  const minuteRef = useRef(0);
  const secondRef = useRef(30);

  const getTime = useCallback(() => {
    if (secondRef.current < 0) {
      secondRef.current = 59;
      minuteRef.current--;
    }

    const element = document.getElementById('timer');
    let sec = secondRef.current < 10 ? `0${secondRef.current}` : secondRef.current;
    if (element) element.innerHTML = `Time Remaining ${sec} seconds`;

    secondRef.current--;

    if (minuteRef.current === 0 && secondRef.current < 0) {
      clearInterval(intervalRef.current);
      onCompletion();
    }
  }, [onCompletion]);

  useEffect(() => {
    if (show) {
      minuteRef.current = 0;
      secondRef.current = 30;

      intervalRef.current = setInterval(getTime, 1000);
    }

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [show, getTime]);

  return show && <div id="timer"></div>;
};
